import fileDownload from 'js-file-download';
import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import store from '@/state/store';
import { affiliateAPI, campaignAPI } from '@samclick-static-urls';
import { sendGet, sendPut, sendPost } from '@samclick-api-client';
import { sendUAGet, sendUAPostBlobResponse } from '@/api-client/unified-api';
import { affiliateAPI as affiliateUAAPI } from "@/api-client/static-url-ua";
import Payload from './payload';

class MeReports {
    banner_displays = 0
    clicks = 0
    registrants = 0
    ftd = 0
    active = 0
    sales = 0.00
    commission = 0.00
    cpa = 0.00
    adjustments = 0.00
    tier_commission = 0.00
    total = 0.00
    rows = []
}

function calculateAchievementTotal(commission: number, tierCommission: number, cpa: number, adjustments: number) {
    return Math.max(commission, 0) + Math.max(tierCommission, 0) + cpa + adjustments;
}

class MyaaffiliateState {
    public loading: boolean = false

    public responseFromCreate: object = {}

    public mereports: MeReports = new MeReports()

    public mereportsrows: object[] = []

    public casinoreports: object[] = []

    public memonthlyreports: object = {}

    public dashboardreports: object = {}
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'myaaffiliate',
})
class MyaaffiliateStore extends VuexModule {
    myaaffiliateStore: MyaaffiliateState = new MyaaffiliateState();

    @Mutation
    MYAAFFILIATE_REINITIALIZE() {
        this.myaaffiliateStore = new MyaaffiliateState();
    }

    @Mutation
    SET_MYAAFFILIATE_LOADING(loading: boolean) {
        this.myaaffiliateStore.loading = loading;
    }

  @Mutation
    SET_MYAAFFILIATE_REPORT(response: MeReports) {
        this.myaaffiliateStore.mereports = response
        this.myaaffiliateStore.mereports.total = calculateAchievementTotal(
            this.myaaffiliateStore.mereports.commission,
            this.myaaffiliateStore.mereports.tier_commission,
            this.myaaffiliateStore.mereports.cpa,
            this.myaaffiliateStore.mereports.adjustments,
        )
    }

  @Mutation
  SET_MYAAFFILIATE_REPORT_ROWS(response: object[]) {
      this.myaaffiliateStore.mereportsrows = response.affiliates_report || [];
  }

  @Mutation
  SET_MYAAFFILIATE_CASINO_REPORT(response: object[]) {
      this.myaaffiliateStore.casinoreports = response || [];
  }

  @Mutation
  SET_MYAAFFILIATE_MONTHLY_REPORT(response: object) {
      this.myaaffiliateStore.memonthlyreports = response || {};
  }

  @Mutation
  SET_DASHBOARD_REPORT(response: object) {
      this.myaaffiliateStore.dashboardreports = response || {};
  }

  @Action({ rawError: true })
  showLoader(show: boolean) {
      this.context.commit('SET_MYAAFFILIATE_LOADING', show);
  }

  @Action({ rawError: true })
  destroyMyaaffiliate() {
      this.context.commit('MYAAFFILIATE_REINITIALIZE');
  }

  @Mutation
  SAMPLE_MUTATION(response: object) {
      this.myaaffiliateStore.responseFromCreate = response;
  }

  @Action({ rawError: true })
  signUp(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendPost(affiliateAPI.affiliateRegistration, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  resendVerification(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendPost(affiliateAPI.resendVerification, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  sendVerificationEmail(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendPost(affiliateAPI.verificationEmail, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  passwordReset(payload: Payload) {
      this.showLoader(true);
      return new Promise((resolve, reject) => {
          sendGet(affiliateAPI.changePass, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  updatePassword(payload: object) {
      return new Promise((resolve, reject) => {
          sendPost(affiliateAPI.updatePassword, payload.data).then((response) => {
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  sendEmailPasswordUpdate(payload: object) {
      return new Promise((resolve, reject) => {
          sendPost(affiliateAPI.updatePassword, payload.data).then((response) => {
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  MeReport(payload: Payload = new Payload()) {
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.getAffiliateSalesTotals, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_MYAAFFILIATE_REPORT', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  MeReportRows(payload: Payload = new Payload()) {
      this.showLoader(false);
      this.context.commit('SET_MYAAFFILIATE_REPORT_ROWS', []);
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.getAffiliateSummaryReports, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_MYAAFFILIATE_REPORT_ROWS', response.data);
              }
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }
  @Action({ rawError: true })
  GetCasinosWithDaySales(payload: Payload = new Payload()) {
      this.showLoader(false);
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.getCasinosWithDaySales, payload.data).then((response) => {
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  CasinoReport(payload: Payload = new Payload()) {
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.getAffiliateCasinoReports, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_MYAAFFILIATE_CASINO_REPORT', response.data.rows);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  exportAchievement(payload: Payload = new Payload()) {
      this.showLoader(false);
      return new Promise((resolve, reject) => {
          sendUAPostBlobResponse(affiliateUAAPI.exportAffiliateSummaryReports, payload.data).then((response) => {
              fileDownload(response.data, 'report-file.csv');
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  MeMonthlyReport(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.getAffiliateFinancialReports, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_MYAAFFILIATE_MONTHLY_REPORT', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  exportMeMonthlyReport(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.exportAffiliateFinancialReports, payload.data, true).then((response) => {
              fileDownload(response.data, 'report-file.csv');
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  affiliateDashboardReport(payload: Payload = new Payload()) {
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.getAffiliateDashboardReports, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_DASHBOARD_REPORT', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

}


export default getModule(MyaaffiliateStore);
